// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.twofa-verify-page {
  min-height: 100vh;
  background: radial-gradient(119.46% 119.46% at 50.12% 119.46%, rgb(129, 131, 236) 0px, rgb(20, 20, 60) 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  position: relative;
  overflow: hidden;
}

.twofa-verify-page::before {
  content: '';
  position: absolute;
  top: -50%;
  right: -50%;
  width: 100%;
  height: 100%;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%);
  animation: float 20s ease-in-out infinite;
}

.twofa-verify-page .page_logo {
  width: 100%;
  max-width: 460px;
  text-align: center;
  margin-bottom: 20px;
  position: relative;
  z-index: 10;
}

.twofa-verify-page .page_logo a {
  display: inline-block;
  text-decoration: none;
}

.twofa-verify-page .page_logo img {
  max-width: 200px;
  width: auto;
  height: auto;
  filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.15));
  transition: transform 0.3s ease;
}

.twofa-verify-page .page_logo img:hover {
  transform: scale(1.05);
}

@keyframes float {

  0%,
  100% {
    transform: translate(0, 0) rotate(0deg);
  }

  50% {
    transform: translate(-20px, 20px) rotate(180deg);
  }
}

.twofa-verify-container {
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(10px);
  border-radius: 24px;
  padding: 48px 40px;
  max-width: 460px;
  width: 100%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(255, 255, 255, 0.5);
  text-align: center;
  margin-top: 20px;
  position: relative;
  animation: slideUp 0.5s ease-out;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.twofa-icon-wrapper {
  position: relative;
  width: 90px;
  height: 90px;
  margin: 0 auto 28px;
}

.twofa-icon {
  width: 90px;
  height: 90px;
  background: linear-gradient(135deg, #4346ce 0%, #4346ce 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 2;
  box-shadow: 0 8px 24px rgba(67, 70, 206, 0.4);
}

.twofa-icon svg {
  font-size: 38px;
  color: white;
}

.twofa-icon-pulse {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: linear-gradient(135deg, #4346ce 0%, #4346ce 100%);
  opacity: 0.3;
  animation: pulse 2s ease-out infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 0.3;
  }

  100% {
    transform: scale(1.5);
    opacity: 0;
  }
}

.twofa-verify-container h1 {
  font-size: 28px;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0 0 12px;
  letter-spacing: -0.5px;
}

.twofa-subtitle {
  color: #64748b;
  font-size: 15px;
  margin: 0 0 24px;
  line-height: 1.5;
}

.twofa-email-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(135deg, #f0f4ff 0%, #e8eeff 100%);
  border: 1px solid #d0d9ff;
  padding: 10px 20px;
  border-radius: 12px;
  margin-bottom: 32px;
  font-size: 14px;
  color: #4346ce;
  font-weight: 500;
}

.email-icon {
  font-size: 16px;
}

.email-text {
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.code-input-container {
  margin-bottom: 28px;
  position: relative;
}

.code-inputs {
  display: flex;
  gap: 10px;
  justify-content: center;
  position: relative;
}

.code-input {
  width: 54px;
  height: 64px;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  font-size: 28px;
  font-weight: 700;
  text-align: center;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  outline: none;
  background: #ffffff;
  color: #1e293b;
  caret-color: #4346ce;
}

.code-input:focus {
  border-color: #4346ce;
  box-shadow: 0 0 0 4px rgba(67, 70, 206, 0.12);
  transform: scale(1.05);
}

.code-input.filled {
  border-color: #4346ce;
  background: linear-gradient(135deg, #f8f9ff 0%, #f0f4ff 100%);
}

.code-input.error {
  border-color: #ef4444;
  animation: shake 0.4s cubic-bezier(0.36, 0.07, 0.19, 0.97);
  background: #fef2f2;
}

.code-input:disabled {
  background: #f8fafc;
  cursor: not-allowed;
  opacity: 0.6;
}

.code-separator {
  position: absolute;
  bottom: -12px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 4px;
}

.code-separator span {
  width: 6px;
  height: 6px;
  background: #cbd5e1;
  border-radius: 50%;
  opacity: 0.5;
}

@keyframes shake {

  0%,
  100% {
    transform: translateX(0);
  }

  10%,
  30%,
  50%,
  70%,
  90% {
    transform: translateX(-8px);
  }

  20%,
  40%,
  60%,
  80% {
    transform: translateX(8px);
  }
}

.twofa-error {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #dc2626;
  font-size: 14px;
  margin-bottom: 20px;
  padding: 12px 16px;
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  border: 1px solid #fecaca;
  border-radius: 12px;
  animation: errorSlide 0.3s ease-out;
}

.error-icon {
  font-size: 16px;
}

@keyframes errorSlide {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.twofa-verify-btn {
  width: 100%;
  padding: 16px 24px;
  background: linear-gradient(135deg, #4346ce 0%, #4346ce 100%);
  color: white;
  border: none;
  border-radius: 14px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  box-shadow: 0 4px 16px rgba(67, 70, 206, 0.4);
  position: relative;
  overflow: hidden;
}

.twofa-verify-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s;
}

.twofa-verify-btn:hover:not(:disabled)::before {
  left: 100%;
}

.twofa-verify-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #5568d3 0%, #6a3f8f 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 24px rgba(67, 70, 206, 0.5);
}

.twofa-verify-btn:active:not(:disabled) {
  transform: translateY(0);
}

.twofa-verify-btn:disabled {
  background: linear-gradient(135deg, #cbd5e1 0%, #94a3b8 100%);
  cursor: not-allowed;
  box-shadow: none;
  opacity: 0.6;
}

.twofa-verify-btn.loading {
  pointer-events: none;
}

.btn-arrow {
  font-size: 18px;
  transition: transform 0.3s ease;
}

.twofa-verify-btn:hover:not(:disabled) .btn-arrow {
  transform: translateX(4px);
}

.twofa-divider {
  margin: 28px 0 20px;
  position: relative;
  text-align: center;
}

.twofa-divider::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, #e2e8f0, transparent);
}

.twofa-divider span {
  position: relative;
  background: rgba(255, 255, 255, 0.98);
  padding: 0 16px;
  font-size: 13px;
  color: #94a3b8;
  font-weight: 500;
}

.twofa-help {
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 24px;
}

.help-link {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  padding: 10px 16px;
  border-radius: 10px;
  font-size: 13px;
  color: #475569;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.help-link:hover {
  background: #f1f5f9;
  border-color: #cbd5e1;
  color: #4346ce;
  transform: translateY(-1px);
}

a.help-link-anchor {
  text-decoration: none;
}

.twofa-recovery-input-wrap {
  margin-bottom: 0;
  text-align: left;
}

.twofa-recovery-input {
  width: 100%;
  box-sizing: border-box;
  padding: 14px 16px;
  font-size: 16px;
  letter-spacing: 0.04em;
  border-radius: 12px;
  border: 2px solid #e2e8f0;
  font-family: ui-monospace, monospace;
}

.twofa-recovery-input:focus {
  outline: none;
  border-color: #4346ce;
}

.twofa-recovery-input.error {
  border-color: #ef4444;
}

.help-icon {
  font-size: 14px;
}

.twofa-back-btn {
  margin-top: 8px;
  background: none;
  border: none;
  color: #64748b;
  font-size: 14px;
  cursor: pointer;
  padding: 10px 20px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 10px;
  font-weight: 500;
}

.twofa-back-btn:hover {
  color: #4346ce;
  background: #f8fafc;
}

.back-arrow {
  transition: transform 0.2s ease;
}

.twofa-back-btn:hover .back-arrow {
  transform: translateX(-3px);
}

/* Responsive */
@media (max-width: 480px) {
  .twofa-verify-page .page_logo {
    margin-bottom: 16px;
  }

  .twofa-verify-page .page_logo img {
    max-width: 180px;
  }

  .twofa-verify-container {
    padding: 36px 24px;
    border-radius: 20px;
  }

  .twofa-verify-container h1 {
    font-size: 24px;
  }

  .twofa-icon-wrapper {
    width: 75px;
    height: 75px;
  }

  .twofa-icon {
    width: 75px;
    height: 75px;
  }

  .twofa-icon svg {
    font-size: 32px;
  }

  .code-input {
    width: 46px;
    height: 56px;
    font-size: 24px;
  }

  .code-inputs {
    gap: 8px;
  }

  .twofa-help {
    flex-direction: column;
  }

  .help-link {
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 360px) {
  .twofa-verify-page .page_logo img {
    max-width: 160px;
  }

  .code-input {
    width: 40px;
    height: 50px;
    font-size: 20px;
  }

  .code-inputs {
    gap: 6px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/auth/TwoFactorVerify.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,4GAA4G;EAC5G,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iFAAiF;EACjF,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mDAAmD;EACnD,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE;;IAEE,uCAAuC;EACzC;;EAEA;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,+EAA+E;EAC/E,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE;IACE,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,qBAAqB;IACrB,UAAU;EACZ;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,6DAA6D;EAC7D,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iDAAiD;EACjD,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,6DAA6D;AAC/D;;AAEA;EACE,qBAAqB;EACrB,0DAA0D;EAC1D,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;;EAEE;;IAEE,wBAAwB;EAC1B;;EAEA;;;;;IAKE,2BAA2B;EAC7B;;EAEA;;;;IAIE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,6CAA6C;EAC7C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,QAAQ;EACR,WAAW;EACX,qEAAqE;AACvE;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,eAAe;AACf;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;AACF","sourcesContent":[".twofa-verify-page {\n  min-height: 100vh;\n  background: radial-gradient(119.46% 119.46% at 50.12% 119.46%, rgb(129, 131, 236) 0px, rgb(20, 20, 60) 100%);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 20px;\n  position: relative;\n  overflow: hidden;\n}\n\n.twofa-verify-page::before {\n  content: '';\n  position: absolute;\n  top: -50%;\n  right: -50%;\n  width: 100%;\n  height: 100%;\n  background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%);\n  animation: float 20s ease-in-out infinite;\n}\n\n.twofa-verify-page .page_logo {\n  width: 100%;\n  max-width: 460px;\n  text-align: center;\n  margin-bottom: 20px;\n  position: relative;\n  z-index: 10;\n}\n\n.twofa-verify-page .page_logo a {\n  display: inline-block;\n  text-decoration: none;\n}\n\n.twofa-verify-page .page_logo img {\n  max-width: 200px;\n  width: auto;\n  height: auto;\n  filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.15));\n  transition: transform 0.3s ease;\n}\n\n.twofa-verify-page .page_logo img:hover {\n  transform: scale(1.05);\n}\n\n@keyframes float {\n\n  0%,\n  100% {\n    transform: translate(0, 0) rotate(0deg);\n  }\n\n  50% {\n    transform: translate(-20px, 20px) rotate(180deg);\n  }\n}\n\n.twofa-verify-container {\n  background: rgba(255, 255, 255, 0.98);\n  backdrop-filter: blur(10px);\n  border-radius: 24px;\n  padding: 48px 40px;\n  max-width: 460px;\n  width: 100%;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(255, 255, 255, 0.5);\n  text-align: center;\n  margin-top: 20px;\n  position: relative;\n  animation: slideUp 0.5s ease-out;\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.twofa-icon-wrapper {\n  position: relative;\n  width: 90px;\n  height: 90px;\n  margin: 0 auto 28px;\n}\n\n.twofa-icon {\n  width: 90px;\n  height: 90px;\n  background: linear-gradient(135deg, #4346ce 0%, #4346ce 100%);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  z-index: 2;\n  box-shadow: 0 8px 24px rgba(67, 70, 206, 0.4);\n}\n\n.twofa-icon svg {\n  font-size: 38px;\n  color: white;\n}\n\n.twofa-icon-pulse {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #4346ce 0%, #4346ce 100%);\n  opacity: 0.3;\n  animation: pulse 2s ease-out infinite;\n}\n\n@keyframes pulse {\n  0% {\n    transform: scale(1);\n    opacity: 0.3;\n  }\n\n  100% {\n    transform: scale(1.5);\n    opacity: 0;\n  }\n}\n\n.twofa-verify-container h1 {\n  font-size: 28px;\n  font-weight: 700;\n  color: #1a1a2e;\n  margin: 0 0 12px;\n  letter-spacing: -0.5px;\n}\n\n.twofa-subtitle {\n  color: #64748b;\n  font-size: 15px;\n  margin: 0 0 24px;\n  line-height: 1.5;\n}\n\n.twofa-email-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: linear-gradient(135deg, #f0f4ff 0%, #e8eeff 100%);\n  border: 1px solid #d0d9ff;\n  padding: 10px 20px;\n  border-radius: 12px;\n  margin-bottom: 32px;\n  font-size: 14px;\n  color: #4346ce;\n  font-weight: 500;\n}\n\n.email-icon {\n  font-size: 16px;\n}\n\n.email-text {\n  max-width: 250px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.code-input-container {\n  margin-bottom: 28px;\n  position: relative;\n}\n\n.code-inputs {\n  display: flex;\n  gap: 10px;\n  justify-content: center;\n  position: relative;\n}\n\n.code-input {\n  width: 54px;\n  height: 64px;\n  border: 2px solid #e2e8f0;\n  border-radius: 12px;\n  font-size: 28px;\n  font-weight: 700;\n  text-align: center;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  outline: none;\n  background: #ffffff;\n  color: #1e293b;\n  caret-color: #4346ce;\n}\n\n.code-input:focus {\n  border-color: #4346ce;\n  box-shadow: 0 0 0 4px rgba(67, 70, 206, 0.12);\n  transform: scale(1.05);\n}\n\n.code-input.filled {\n  border-color: #4346ce;\n  background: linear-gradient(135deg, #f8f9ff 0%, #f0f4ff 100%);\n}\n\n.code-input.error {\n  border-color: #ef4444;\n  animation: shake 0.4s cubic-bezier(0.36, 0.07, 0.19, 0.97);\n  background: #fef2f2;\n}\n\n.code-input:disabled {\n  background: #f8fafc;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.code-separator {\n  position: absolute;\n  bottom: -12px;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  gap: 4px;\n}\n\n.code-separator span {\n  width: 6px;\n  height: 6px;\n  background: #cbd5e1;\n  border-radius: 50%;\n  opacity: 0.5;\n}\n\n@keyframes shake {\n\n  0%,\n  100% {\n    transform: translateX(0);\n  }\n\n  10%,\n  30%,\n  50%,\n  70%,\n  90% {\n    transform: translateX(-8px);\n  }\n\n  20%,\n  40%,\n  60%,\n  80% {\n    transform: translateX(8px);\n  }\n}\n\n.twofa-error {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  color: #dc2626;\n  font-size: 14px;\n  margin-bottom: 20px;\n  padding: 12px 16px;\n  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);\n  border: 1px solid #fecaca;\n  border-radius: 12px;\n  animation: errorSlide 0.3s ease-out;\n}\n\n.error-icon {\n  font-size: 16px;\n}\n\n@keyframes errorSlide {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.twofa-verify-btn {\n  width: 100%;\n  padding: 16px 24px;\n  background: linear-gradient(135deg, #4346ce 0%, #4346ce 100%);\n  color: white;\n  border: none;\n  border-radius: 14px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  box-shadow: 0 4px 16px rgba(67, 70, 206, 0.4);\n  position: relative;\n  overflow: hidden;\n}\n\n.twofa-verify-btn::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);\n  transition: left 0.5s;\n}\n\n.twofa-verify-btn:hover:not(:disabled)::before {\n  left: 100%;\n}\n\n.twofa-verify-btn:hover:not(:disabled) {\n  background: linear-gradient(135deg, #5568d3 0%, #6a3f8f 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 24px rgba(67, 70, 206, 0.5);\n}\n\n.twofa-verify-btn:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.twofa-verify-btn:disabled {\n  background: linear-gradient(135deg, #cbd5e1 0%, #94a3b8 100%);\n  cursor: not-allowed;\n  box-shadow: none;\n  opacity: 0.6;\n}\n\n.twofa-verify-btn.loading {\n  pointer-events: none;\n}\n\n.btn-arrow {\n  font-size: 18px;\n  transition: transform 0.3s ease;\n}\n\n.twofa-verify-btn:hover:not(:disabled) .btn-arrow {\n  transform: translateX(4px);\n}\n\n.twofa-divider {\n  margin: 28px 0 20px;\n  position: relative;\n  text-align: center;\n}\n\n.twofa-divider::before {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 0;\n  right: 0;\n  height: 1px;\n  background: linear-gradient(90deg, transparent, #e2e8f0, transparent);\n}\n\n.twofa-divider span {\n  position: relative;\n  background: rgba(255, 255, 255, 0.98);\n  padding: 0 16px;\n  font-size: 13px;\n  color: #94a3b8;\n  font-weight: 500;\n}\n\n.twofa-help {\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n  flex-wrap: wrap;\n  margin-bottom: 24px;\n}\n\n.help-link {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  padding: 10px 16px;\n  border-radius: 10px;\n  font-size: 13px;\n  color: #475569;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.help-link:hover {\n  background: #f1f5f9;\n  border-color: #cbd5e1;\n  color: #4346ce;\n  transform: translateY(-1px);\n}\n\na.help-link-anchor {\n  text-decoration: none;\n}\n\n.twofa-recovery-input-wrap {\n  margin-bottom: 0;\n  text-align: left;\n}\n\n.twofa-recovery-input {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 14px 16px;\n  font-size: 16px;\n  letter-spacing: 0.04em;\n  border-radius: 12px;\n  border: 2px solid #e2e8f0;\n  font-family: ui-monospace, monospace;\n}\n\n.twofa-recovery-input:focus {\n  outline: none;\n  border-color: #4346ce;\n}\n\n.twofa-recovery-input.error {\n  border-color: #ef4444;\n}\n\n.help-icon {\n  font-size: 14px;\n}\n\n.twofa-back-btn {\n  margin-top: 8px;\n  background: none;\n  border: none;\n  color: #64748b;\n  font-size: 14px;\n  cursor: pointer;\n  padding: 10px 20px;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  border-radius: 10px;\n  font-weight: 500;\n}\n\n.twofa-back-btn:hover {\n  color: #4346ce;\n  background: #f8fafc;\n}\n\n.back-arrow {\n  transition: transform 0.2s ease;\n}\n\n.twofa-back-btn:hover .back-arrow {\n  transform: translateX(-3px);\n}\n\n/* Responsive */\n@media (max-width: 480px) {\n  .twofa-verify-page .page_logo {\n    margin-bottom: 16px;\n  }\n\n  .twofa-verify-page .page_logo img {\n    max-width: 180px;\n  }\n\n  .twofa-verify-container {\n    padding: 36px 24px;\n    border-radius: 20px;\n  }\n\n  .twofa-verify-container h1 {\n    font-size: 24px;\n  }\n\n  .twofa-icon-wrapper {\n    width: 75px;\n    height: 75px;\n  }\n\n  .twofa-icon {\n    width: 75px;\n    height: 75px;\n  }\n\n  .twofa-icon svg {\n    font-size: 32px;\n  }\n\n  .code-input {\n    width: 46px;\n    height: 56px;\n    font-size: 24px;\n  }\n\n  .code-inputs {\n    gap: 8px;\n  }\n\n  .twofa-help {\n    flex-direction: column;\n  }\n\n  .help-link {\n    width: 100%;\n    justify-content: center;\n  }\n}\n\n@media (max-width: 360px) {\n  .twofa-verify-page .page_logo img {\n    max-width: 160px;\n  }\n\n  .code-input {\n    width: 40px;\n    height: 50px;\n    font-size: 20px;\n  }\n\n  .code-inputs {\n    gap: 6px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
